export const createEnumOptions = (optionsMap: Array<{ value: string; label: string }>) => {
	const record: Record<string, string> = optionsMap.reduce((obj, item) => {
		obj[item.value] = item.label
		return obj
	}, {} as Record<string, string>)

	return record
}
